export default __webpack_public_path__ + "static/media/glasses-red-eye.ded1ec12.svg";